import { ViewControls } from './ViewControls';
import { ImageIcon, CloseIcon } from '@/components/icons';
import useStyles from './HeaderRight.styles';

import type { SizeValue } from '@/components/shared/SizeSelector';

interface HeaderRightProps {
  isAuthorized: boolean | undefined;
  showViewControls: boolean;
  showGenerationsButton: boolean;
  viewCrop: boolean;
  viewSize: SizeValue;
  onLogin: () => void;
  onCropToggle: () => void;
  onSizeChange: (size: SizeValue) => void;
  onGenerationsClick: () => void;
  onCloseApp: () => void;
}

export const HeaderRight = ({
  isAuthorized,
  showViewControls,
  showGenerationsButton,
  viewCrop,
  viewSize,
  onLogin,
  onCropToggle,
  onSizeChange,
  onGenerationsClick,
  onCloseApp,
}: HeaderRightProps) => {
  const classes = useStyles();

  return (
    <div className={classes.right}>
      {/* Login button - shown when not authorized */}
      {!isAuthorized && (
        <button
          type="button"
          className={classes.loginButton}
          onClick={onLogin}
          title="Log in"
          aria-label="Log in"
        >
          Log in
        </button>
      )}
      {/* View controls - mobile only, library screen */}
      {showViewControls && (
        <ViewControls
          viewCrop={viewCrop}
          viewSize={viewSize}
          onCropToggle={onCropToggle}
          onSizeChange={onSizeChange}
        />
      )}
      {/* Generations button - CSS hides on desktop */}
      {showGenerationsButton && (
        <button
          type="button"
          className={classes.generationsButton}
          onClick={onGenerationsClick}
          title="Your Creations"
          aria-label="Your Creations"
        >
          <ImageIcon />
        </button>
      )}
      {/* Close button - CSS hides on desktop */}
      <button
        type="button"
        className={classes.closeButton}
        onClick={onCloseApp}
        title="Close"
        aria-label="Close app"
      >
        <CloseIcon width="20" height="20" />
      </button>
    </div>
  );
};
